// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import ImageGallery from "react-image-gallery";
// import { Card as BootstrapCard } from "react-bootstrap";
// import { FcEditImage } from "react-icons/fc";
// import { MdDelete } from "react-icons/md";
// import "react-image-gallery/styles/css/image-gallery.css";
// import { useAuthHeaders } from "../../components/Token";
// import { API_BASE_URL } from "../../utils";
// import { useParams } from "react-router-dom";

// const MyGallery = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [data, setdata] = useState([]);
//   const { id } = useParams();
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/property/getproperty/${id}`, { headers })
//       .then((response) => {
//         console.log(response.data.data.type); // Check the structure of response.data
//          setdata(response?.data?.data)
//         const fetchedProperties = response?.data?.data;

//         if (Array.isArray(fetchedProperties)) {
//           const transformedProperties = fetchedProperties.map((property) => ({
//             _id: property._id,
//             propertyTitle: property.propertyTitle,
//             location: property.location,
//             images: property.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),
//           }));
//           setProperties(transformedProperties);
//         } else if (
//           typeof fetchedProperties === "object" &&
//           fetchedProperties !== null
//         ) {
//           // Handle single object case
//           const transformedProperty = {
//             _id: fetchedProperties._id,
//             propertyTitle: fetchedProperties.propertyTitle,
//             location: fetchedProperties.location,
//             images: fetchedProperties.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),
//           };
//           setProperties([transformedProperty]); // Convert to array for consistency
//         } else {
//           console.error("Unexpected API response format");
//         }
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching properties:", error);
//         setLoading(false);
//       });
//   }, [id, headers]);

//   const handleImageClick = (id) => {
//     console.log("Image clicked with ID:", id);
//     // Implement your logic for image click here
//   };

//   const handleEdit = (id) => {
//     console.log("Edit clicked with ID:", id);
//     // Implement your edit logic here
//   };

//   const handleDelete = (id) => {
//     console.log("Delete clicked with ID:", id);
//     // Implement your delete logic here
//   };

//   return (
//     <div className="row">
//       <div className="col-md-6 mt-4 ">
//         <ImageGallery
//           items={properties.flatMap((property) => property.images)}
//         />
//       </div>
//       <div className="col">
//         <div className="card-container">
//           <div className="row">
//             {properties.length > 0 ? (
//               properties.map((property, index) => (

//                 <div className="col-md-6 mt-4" key={index}>
//                   <div className="card">
//                     <div className="card-title m-4 ">
//                       {console.log(property.type)}
//                       <p>PropertyTitle : {property?.propertyTitle}</p>
//                       <p>Type : {property?.type}</p>
//                       <p>propertyType : {property?.propertyType}</p>
//                       <p>address :  {property?.address}  </p>
//                       <p>propertyFacing : {property?.propertyFacing}</p>
//                       <p>location :{property?.location} </p>
//                       <p>price :{property?.price}</p>

//                       <p>propertyDescription: {property?.propertyDescription}</p>
//                       <p>slug: {property?.slug}</p>
//                       <p>totalArea :{property?.totalArea}</p>

//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="m-auto mt-5">
//                 <p className="text-center">No properties found....</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyGallery;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import ImageGallery from "react-image-gallery";
// import { Card as BootstrapCard } from "react-bootstrap";
// import { FcEditImage } from "react-icons/fc";
// import { MdDelete } from "react-icons/md";
// import "react-image-gallery/styles/css/image-gallery.css";
// import { useAuthHeaders } from "../../components/Token";
// import { API_BASE_URL } from "../../utils";
// import { useParams } from "react-router-dom";

// const MyGallery = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const { id } = useParams();
//   const headers = useAuthHeaders();

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/property/getproperty/${id}`, { headers })
//       .then((response) => {
//         console.log(response.data.data); // Check the structure of response.data
//         const fetchedProperties = response?.data?.data;

//         if (Array.isArray(fetchedProperties)) {
//           const transformedProperties = fetchedProperties.map((property) => ({
//             _id: property._id,
//             propertyTitle: property.propertyTitle,
//             location: property.location,
//             type: property.type,
//             propertyType: property.propertyType,
//             address: property.address,
//             propertyFacing: property.propertyFacing,
//             price: property.price,
//             propertyDescription: property.propertyDescription,
//             slug: property.slug,
//             totalArea: property.totalArea,
//             images: property.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),
//           }));
//           setProperties(transformedProperties);
//         } else if (
//           typeof fetchedProperties === "object" &&
//           fetchedProperties !== null
//         ) {
//           // Handle single object case
//           const transformedProperty = {
//             _id: fetchedProperties._id,
//             propertyTitle: fetchedProperties.propertyTitle,
//             location: fetchedProperties.location,
//             type: fetchedProperties.type,
//             propertyType: fetchedProperties.propertyType,
//             address: fetchedProperties.address,
//             propertyFacing: fetchedProperties.propertyFacing,
//             price: fetchedProperties.price,
//             propertyDescription: fetchedProperties.propertyDescription,
//             slug: fetchedProperties.slug,
//             totalArea: fetchedProperties.totalArea,
//             images: fetchedProperties.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),
//           };
//           setProperties([transformedProperty]); // Convert to array for consistency
//         } else {
//           console.error("Unexpected API response format");
//         }
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching properties:", error);
//         setLoading(false);
//       });
//   }, [id, headers]);

//   const handleImageClick = (id) => {
//     console.log("Image clicked with ID:", id);
//     // Implement your logic for image click here
//   };

//   const handleEdit = (id) => {
//     console.log("Edit clicked with ID:", id);
//     // Implement your edit logic here
//   };

//   const handleDelete = (id) => {
//     console.log("Delete clicked with ID:", id);
//     // Implement your delete logic here
//   };

//   return (
//     <div className="row">
//       <div className="col-md-4 mt-4 ">
//         <ImageGallery
//           items={properties.flatMap((property) => property.images)}
//         />
//       </div>
//       <div className="col">
//         <div className="card-container">
//           <div className="row">
//             {properties.length > 0 ? (
//               properties.map((property, index) => (
//                 <div className="col-md- mt-4" key={index}>
//                   <div className="card">
//                     <div className="card-title m-4 " >
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>PropertyTitle : {property?.propertyTitle}</p>
//                       <p className="fs-6 fw-light"style={{fontSize:"16px"}}>Type : {property?.type}</p>
//                       <p className="fs-6 fw-light"style={{fontSize:"16px"}}>Property Type : {property?.propertyType}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Address : {property?.address}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Property Facing : {property?.propertyFacing}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Location : {property?.location}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Price : {property?.price}</p>
//                       <p className="fs-6 fw-light"style={{fontSize:"16px"}}>Property Description : {property?.propertyDescription}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Slug : {property?.slug}</p>
//                       <p className="fs-6 fw-light" style={{fontSize:"16px"}}>Total Area : {property?.totalArea}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="m-auto mt-5">
//                 <p className="text-center">No properties found....</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyGallery;import React, { useEffect, useState } from "react";
// import axios from "axios";
// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";
// import { useAuthHeaders } from "../../components/Token";
// import { API_BASE_URL } from "../../utils";
// import { useParams } from "react-router-dom";
// import { useState, useEffect } from "react";
// const MyGallery = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const { id } = useParams();
//   const headers = useAuthHeaders();

//   const stripHtmlTags = (html) => {
//     const tmp = document.createElement("div");
//     tmp.innerHTML = html;
//     return tmp.textContent || tmp.innerText || "";
//   };
//   const formatDate = (dateString) => {
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/property/getproperty/${id}`, { headers })
//       .then((response) => {
//         console.log(response.data.data); // Check the structure of response.data
//         const fetchedProperties = response?.data?.data;

//         if (Array.isArray(fetchedProperties)) {
//           const transformedProperties = fetchedProperties.map((property) => ({
//             _id: property._id,
//             propertyTitle: property.propertyTitle,
//             location: property.location,
//             type: property.type,
//             propertyType: property.propertyType,
//             address: property.address,
//             propertyFacing: property.propertyFacing,
//             price: property.price,
//             propertyDescription: property.propertyDescription,
//             slug: property.slug,
//             totalArea: property.totalArea,
//             createdAt: fetchedProperties.createdAt,

//             images: property.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),updatedAt: formatDate(property.updatedAt),
//           }));
//           setProperties(transformedProperties);
//         } else if (
//           typeof fetchedProperties === "object" &&
//           fetchedProperties !== null
//         ) {
//           // Handle single object case
//           const transformedProperty = {
//             _id: fetchedProperties._id,
//             propertyTitle: fetchedProperties.propertyTitle,
//             location: fetchedProperties.location,
//             type: fetchedProperties.type,
//             propertyType: fetchedProperties.propertyType,
//             address: fetchedProperties.address,
//             propertyFacing: fetchedProperties.propertyFacing,
//             price: fetchedProperties.price,
//             propertyDescription: fetchedProperties.propertyDescription,
//             slug: fetchedProperties.slug,
//             totalArea: fetchedProperties.totalArea,
//             createdAt: fetchedProperties.createdAt,
//             updatedAt: fetchedProperties.updatedAt,

//             images: fetchedProperties.propertyImages.map((image) => ({
//               original: image.propertyImage,
//               thumbnail: image.propertyImage,
//             })),
//           };
//           setProperties([transformedProperty]); // Convert to array for consistency
//         } else {
//           console.error("Unexpected API response format");
//         }
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching properties:", error);
//         setLoading(false);
//       });
//   }, [id, headers]);

//   return (
//     <div className="row">
//       <div className="col-md-6 mt-4">
//         {loading ? (
//           <p>Loading...</p>
//         ) : (
//           <ImageGallery
//             items={properties.flatMap((property) => property.images)}
//           />
//         )}
//       </div>
//       <div className="col">
//         <div className="card-container">
//           <div className="row">
//             {loading ? (
//               <p>Loading...</p>
//             ) : properties.length > 0 ? (
//               properties.map((property, index) => (
//                 <div className="col-md-6 mt-4 w-100" key={index}>
//                   <div className="card">
//                     <div className="card-title m-4 ">
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         PropertyTitle : {property?.propertyTitle}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Type : {property?.type}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Property Type : {property?.propertyType}
//                       </p>
//                       <p className="fw-light" style={{ fontSize: "16px" }}>
//                         Address : {property?.address}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Property Facing : {property?.propertyFacing}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Location : {property?.location}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Price : {property?.price}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Property Description :{" "}
//                         {stripHtmlTags(property?.propertyDescription)}
//                       </p>
//                       <p className=" fw-light" style={{ fontSize: "16px" }}>
//                         Slug : {property?.slug}
//                       </p>
//                       <p className="   fw-light" style={{ fontSize: "16px" }}>
//                         Total Area : {property?.totalArea}
//                       </p>
//                       <p className="   fw-light" style={{ fontSize: "16px" }}>
//                         CreatedAt: {property?.createdAt}
//                       </p>
//                       <p>updatedAt: {property?.updatedAt}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="m-auto mt-5">
//                 <p className="text-center">No properties found....</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyGallery;
import axios from "axios";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useAuthHeaders } from "../../components/Token";
import { API_BASE_URL } from "../../utils";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { IoArrowBackCircleSharp } from "react-icons/io5";

const MyGallery = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const headers = useAuthHeaders();

  const stripHtmlTags = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/property/getproperty/${id}`, { headers })
      .then((response) => {
        console.log(response.data.data); // Check the structure of response.data
        const fetchedProperties = response?.data?.data;

        if (Array.isArray(fetchedProperties)) {
          const transformedProperties = fetchedProperties.map((property) => ({
            _id: property._id,
            propertyTitle: property.propertyTitle,
            location: property.location,
            type: property.type,
            propertyType: property.propertyType,
            address: property.address,
            propertyFacing: property.propertyFacing,
            price: property.price,
            propertyDescription: stripHtmlTags(property.propertyDescription),
            slug: property.slug,
            totalArea: property.totalArea,
            createdAt: formatDate(property.createdAt),
            updatedAt: formatDate(property.updatedAt),
            images: property.propertyImages.map((image) => ({
              original: image.propertyImage,
              thumbnail: image.propertyImage,
            })),
          }));
          setProperties(transformedProperties);
        } else if (
          typeof fetchedProperties === "object" &&
          fetchedProperties !== null
        ) {
          // Handle single object case
          const transformedProperty = {
            _id: fetchedProperties._id,
            propertyTitle: fetchedProperties.propertyTitle,
            location: fetchedProperties.location,
            type: fetchedProperties.type,
            propertyType: fetchedProperties.propertyType,
            address: fetchedProperties.address,
            propertyFacing: fetchedProperties.propertyFacing,
            price: fetchedProperties.price,
            propertyDescription: stripHtmlTags(
              fetchedProperties.propertyDescription
            ),
            slug: fetchedProperties.slug,
            totalArea: fetchedProperties.totalArea,
            createdAt: formatDate(fetchedProperties.createdAt),
            updatedAt: formatDate(fetchedProperties.updatedAt),
            images: fetchedProperties.propertyImages.map((image) => ({
              original: image.propertyImage,
              thumbnail: image.propertyImage,
            })),
          };
          setProperties([transformedProperty]); // Convert to array for consistency
        } else {
          console.error("Unexpected API response format");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching properties:", error);
        setLoading(false);
      });
  }, [id, headers]);

  return (
    <div className="row">
      <div className="col-md-6 mt-4">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <ImageGallery
            items={properties.flatMap((property) => property.images)}
          />
        )}
      </div>
      <div className="col">
        <div className="card-container">
          <div className="row">
            {loading ? (
              <p>Loading...</p>
            ) : properties.length > 0 ? (
              properties.map((property, index) => (
                <>
                  <div className="col-md-6 mt-4 w-100" key={index}>
                    <div className="">
                      <div className="  ">
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Property Title:   </span>
                          {property?.propertyTitle}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Type: </span>
                          {property?.type}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Property Type: </span>
                          {property?.propertyType}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          {" "}
                          <span className="fw-semibold">Address: </span>
                          {property?.address}
                        </p>
                        <p className="fw-light " style={{ fontSize: "16px" }}>
                          <span className="fw-semibold ">Property Facing: </span>
                          {property?.propertyFacing}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Location: </span>
                          {property?.location}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Price: </span>
                          {property?.price}
                        </p>
                        {/* <p className="fw-light" style={{ fontSize: "16px" }}>
                        Property Description: {property?.propertyDescription}
                      </p> */}
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">Slug: </span>
                          {property?.slug}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">
                            Total Area: 
                          </span>{property?.totalArea}
                        </p>
                        <p className="fw-light" style={{ fontSize: "16px" }}>
                          <span className="fw-semibold">
                          Created At:  
                          </span>
                           {property?.createdAt}
                        </p>
                        <p className="fw-light " style={{ fontSize: "16px" }}>
                        <span className="fw-semibold ">
                        Updated At: 
                          </span>
                          {property?.updatedAt}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                  <div className="col-12">

                <p className="fw-light" style={{ fontSize: "16px" }}>
                        Property Description: {property?.propertyDescription}
                      </p> 
                  </div>

                </div> */}
               
                </>
              ))
            ) : (
              <div className="m-auto mt-5">
                <p className="text-center">No properties found....</p>
              </div>
            )}
          </div>
          <Link to={"/PropertyView"} className="btn "> <IoArrowBackCircleSharp className="fs-2"/>
          Back</Link>
        </div>
      </div>
    </div>
  );
};

export default MyGallery;
